import React from 'react';
import Distance from './Distance';

export const columns = [
  { id: 'propertyName', label: 'Property Name' },
  { id: 'distance', label: 'Distance' },
];

export const columnRenderers = {
  distance: (columnData) => {
    const { value, row } = columnData;
    return <Distance distance={value} unit={row.unit} />;
  },
  propertyName: (columnData) => {
    return columnData.value;
  },
};
